// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-status-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 50%;
    margin: 50px auto;
}


.status-icon {
    color: #fff;
    font-size: 6rem;
}

.status-icon-wrapper {
    width: 150px;
    height: 150px;
    border-radius: 50%;
    /* background-color: var(--dBlue); */
    background: linear-gradient(to bottom, #7380FF 0%, #977CFF 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
}

.status-titles {
    font-weight: 400;
}

.status-values {
    font-weight: 600;
    text-transform: capitalize;
}

.status-content-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.status-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.dashed-rule {
    margin: 20px 0;
    border: 1px dashed #7380FF;
    width: 100%;
}

.status-icon-wrapper {
    animation: zoom 1s infinite alternate;
    /* 2s duration, infinite repeat, alternate direction */
    transform-origin: center;
}

.transaction-id-text{
    text-align: center;
    font-size: 22px;
}

@keyframes zoom {
    0% {
        transform: scale(0.8);
        /* Start at normal size */
    }

    100% {
        transform: scale(1.2);
        /* End at 120% size */
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/order-success/OrderSuccessWithPayment.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IACV,iBAAiB;AACrB;;;AAGA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,oCAAoC;IACpC,gEAAgE;IAChE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,WAAW;AACf;;AAEA;IACI,qCAAqC;IACrC,sDAAsD;IACtD,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI;QACI,qBAAqB;QACrB,yBAAyB;IAC7B;;IAEA;QACI,qBAAqB;QACrB,qBAAqB;IACzB;AACJ","sourcesContent":[".payment-status-wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 50%;\n    margin: 50px auto;\n}\n\n\n.status-icon {\n    color: #fff;\n    font-size: 6rem;\n}\n\n.status-icon-wrapper {\n    width: 150px;\n    height: 150px;\n    border-radius: 50%;\n    /* background-color: var(--dBlue); */\n    background: linear-gradient(to bottom, #7380FF 0%, #977CFF 100%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto;\n}\n\n.status-titles {\n    font-weight: 400;\n}\n\n.status-values {\n    font-weight: 600;\n    text-transform: capitalize;\n}\n\n.status-content-wrapper {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n}\n\n.status-content {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.dashed-rule {\n    margin: 20px 0;\n    border: 1px dashed #7380FF;\n    width: 100%;\n}\n\n.status-icon-wrapper {\n    animation: zoom 1s infinite alternate;\n    /* 2s duration, infinite repeat, alternate direction */\n    transform-origin: center;\n}\n\n.transaction-id-text{\n    text-align: center;\n    font-size: 22px;\n}\n\n@keyframes zoom {\n    0% {\n        transform: scale(0.8);\n        /* Start at normal size */\n    }\n\n    100% {\n        transform: scale(1.2);\n        /* End at 120% size */\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
